export interface UserConfigServerData {
  SysConfig: any
  UserConfig: any
}

export enum UserConfigServiceErrorCode {
  GENERAL,
  INVALID_OLD_PASSWORD,
}

export interface PasswordRulesServerData {
  LowerCase: number
  MinLength: number
  Numbers: number
  PassHistoryCount: number
  SpecialChars1: string
  SpecialChars2: string
  Specials1: number
  Specials2: number
  UpperCase: number
}

export interface ChangePasswordFailure {
  message: string
}

export enum ConfigItem {
  MyCountryID = 'MyCountryID',
  MyCityID = 'MyCityID',
  AppLang = 'APP_Lang',
  SelectRecent = 'SELECT_RECENT',
  IdleLock = 'IdleLock',
  ForeignCurrency = 'Foreign_Currency',
  ForeignCurrency2 = 'Foreign_Currency2',
  PrintAfterClientAdd = 'Print_After_Client_Add',
  PrintAfterAppAdd = 'Print_After_App_Add',
  PrintAfterLoanAdd = 'Print_After_Loan_Add',
  PrintAfterCollAdd = 'Print_After_Coll_Add',
  WorkPeriodStart = 'WorkPeriodStart',
  WorkPeriodEnd = 'WorkPeriodEnd',
}
